import { Injectable } from '@angular/core';
import {SearchResultsModel} from "@app/search/components/model/search-results.model";
import {SearchResultNamePipe} from "@app/search/components/pipes/search-result-name.pipe";

@Injectable({
  providedIn: 'root'
})
export class MapperService {

  constructor(
    private searchResultNamePipe: SearchResultNamePipe
  ) {
  }

  public mapToResults(data: any): SearchResultsModel {
    const result = {
      totalCount: data.total,
      results: [],
      stats: data.stats,
    };

    if (data.hits) {
      for (const hit of data.hits) {
        const type = this.searchResultNamePipe.mapType(hit.index);
        if (type) {
          result.results.push({
            type: type,
            id: hit.id,
            score: hit.score,
            data: hit.source,
            highlight: hit.highlight
          });
        }
      }
    }

    return result;
  }

}
